import { Box, Button, Grid, TextField } from "@material-ui/core";
import { useState } from "react";
import { toast } from "react-toastify";
import { FeatureDiscount } from "../../app/consts";
import { useIsMounted } from "../../app/utils";
import { useConfig } from "../config/ConfigContext";

interface Props {
  onApply: (promoCode: string) => void;
}

export const DeductionApply = ({ onApply }: Props) => {
  const [promoCode, setPromoCode] = useState("");
  const [disabled, setDisabled] = useState(true);
  const isMounted = useIsMounted();
  const { isFeatureEnabled } = useConfig();

  if (!isFeatureEnabled(FeatureDiscount)) {
    return <></>;
  }

  const resetForm = () => {
    setPromoCode("");
    setDisabled(true);
  };

  const handleApply = async () => {
    setDisabled(true);

    try {
      await onApply(promoCode);

      if (isMounted.current) {
        resetForm();
      }
    } catch (err: any) {
      console.log(err);
      const message = err?.message ?? err;
      toast.error(message);
      setDisabled(false);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setPromoCode(value);
    setDisabled(value.length < 2);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setPromoCode(value);
    setDisabled(value.length < 2);
  };

  return (
    <>
      <Box>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={9}>
            <TextField
              fullWidth
              size="small"
              label="Add Discount Code"
              name="deduction"
              onBlur={handleBlur}
              onChange={handleChange}
              variant="outlined"
              inputProps={{ maxLength: 20 }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Button fullWidth onClick={handleApply} variant="outlined" color="secondary" disabled={disabled}>
              Apply
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
